import { PropsWithChildren } from "react";
import { ReactComponent as XmarkSolid } from "../../assets/icons/font-awesome/xmark-solid.svg";

const Popup = ({
  title,
  children,
  hideHeader = false,
  onClose,
  className = "min-h-3/4 w-60p",
}: PropsWithChildren<{
  hideHeader?: boolean;
  title?: string;
  className?: string;
  onClose?: () => void;
}>) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        onClick={e => e.stopPropagation()}
        className={`flex flex-col modal-content max-h-90p ${className}`}
        style={{ minWidth: "650px" }}
      >
        {!hideHeader && (
          <div className="flex items-center justify-between p-16 border-b bg-neutral-9 rounded-t-8 border-neutral-7">
            <p className="font-700 text-neutral-1">{title}</p>
            <div
              className="flex items-center justify-center w-16 h-16 cursor-pointer"
              onClick={onClose}
            >
              <XmarkSolid className="w-20 h-20 fill-neutral-5 hover:fill-neutral-black" />
            </div>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default Popup;
